// extracted by mini-css-extract-plugin
export default {"content":"Notice_content__lS1Rv","ref":"Notice_ref__ihAsP","board-container":"Notice_board-container__Rahuq","content2":"Notice_content2__2cXKc"};